var map = {
	"./casino-bariloche.jpg": "f711",
	"./catedral-huapi.jpg": "bdea",
	"./messidor.jpg": "017c",
	"./museo-havanna.jpg": "b3dd",
	"./museo-patagonia.jpg": "0cbf",
	"./patagonia-vinos.jpg": "696f",
	"./rapa-nui.jpg": "0c06",
	"./refugio-berghof.jpg": "e592",
	"./san-eduardo.jpg": "a0c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0305";